import { isEqual } from 'lodash-es';
import { DateRange, SearchFilterType } from './types';
export const makeInitialFilterValue = (filterConfig)=>{
    switch(filterConfig.type){
        case SearchFilterType.MultiSelectFilter:
            return [];
        case SearchFilterType.DateRangeFilter:
            return {
                from: undefined,
                to: undefined
            };
        case SearchFilterType.RadioFilter:
            return filterConfig.defaultOption;
        case SearchFilterType.DateRangeWithPresets:
            return {
                dateRangeOption: DateRange.AllTime,
                dateRange: []
            };
        case SearchFilterType.CustomFilter:
            return filterConfig.initialValue;
    }
};
export const isInitialFilterValue = (filterValue, filterConfig)=>isEqual(filterValue, makeInitialFilterValue(filterConfig));
export const isEmptyFilterValue = (value, config)=>{
    var _config_mobile;
    if (value === undefined || value === null) return true;
    if ((_config_mobile = config.mobile) === null || _config_mobile === void 0 ? void 0 : _config_mobile.isEmptyValue) {
        return config.mobile.isEmptyValue(value);
    }
    if (Array.isArray(value) && value.length === 0) return true;
    if (typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0) return true;
    return false;
};
